var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-arrow-right-from-bracket-solid';
                    var viewUrl = 'gfx/sprite.svg#view-icon-arrow-right-from-bracket-solid';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 512 512',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };